import { getPacientes } from 'services/pacientes';
import useSWR from 'swr';

export function usePacientes({ nome = '', cpf = '', dtNasc = '', codPac = '', celular = '' } = {}) {
  const cleanNome = String(nome || '').trim();
  const cleanCpf = String(cpf || '').trim();
  const cleanCelular = String(celular || '').trim();

  const filtros = {
    nome: cleanNome,
    cpf: cleanCpf,
    dtNasc,
    codPac,
    celular: cleanCelular,
  };

  const possuiFiltro =
    filtros.nome.length >= 3 ||
    filtros.cpf.replace(/\D/g, '').length >= 11 ||
    filtros.celular.length >= 4 ||
    Boolean(filtros.dtNasc) ||
    Boolean(filtros.codPac);

  const key = possuiFiltro ? ['pacientes', filtros] : null;

  const swr = useSWR(key, ([, params]) => getPacientes(params), {
    shouldRetryOnError: false,
  });

  return {
    pacientes: swr.data ?? [],
    error: swr.error,
    isLoading: swr.isLoading,
    isValidating: swr.isValidating,
    mutate: swr.mutate,
  };
}
